import React from 'react';

const GameFilters = ({
  filters,
  allCategories,
  isListLoading,
  onFilterChange,
  onSortDirectionToggle,
  onResetFilters,
}) => {
  const initialSortBy = 'title';
  const initialSortDirection = 'asc';

  return (
    <div className="grid" aria-busy={isListLoading}>
      <input
        type="search"
        name="searchTerm"
        placeholder="Filter results by title..."
        value={filters.searchTerm}
        onChange={onFilterChange}
        disabled={isListLoading}
        className={filters.searchTerm ? 'active-filter' : ''}
      />
      <input
        type="number"
        name="playerCount"
        placeholder="Number of players"
        min="1"
        value={filters.playerCount}
        onChange={onFilterChange}
        aria-label="Filter by player count"
        disabled={isListLoading}
        className={filters.playerCount ? 'active-filter' : ''}
      />
      <select
        name="selectedCategory"
        value={filters.selectedCategory}
        onChange={onFilterChange}
        aria-label="Filter by category"
        disabled={isListLoading}
        className={filters.selectedCategory ? 'active-filter' : ''}
      >
        <option value="">All Categories</option>
        {allCategories.map(category => (
          <option key={category} value={category}>{category}</option>
        ))}
      </select>
      <select
        name="sortBy"
        value={filters.sortBy}
        onChange={onFilterChange}
        aria-label="Sort by"
        disabled={isListLoading}
        className={filters.sortBy !== initialSortBy ? 'active-filter' : ''}
      >
        <option value="title">Sort by Title</option>
        <option value="rating">Sort by Rating</option>
        <option value="weight">Sort by Weight</option>
        <option value="time">Sort by Time</option>
      </select>
      <button
        onClick={onSortDirectionToggle}
        className={`secondary ${filters.sortDirection !== initialSortDirection ? 'active-filter' : ''}`}
        title={`Sort direction: ${filters.sortDirection === 'asc' ? 'Ascending' : 'Descending'}`}
        style={{ padding: '0.5rem', width: 'auto' }}
        disabled={isListLoading}
      >
        {filters.sortDirection === 'asc' ? '↑' : '↓'}
      </button>
      <button onClick={onResetFilters} className="secondary" disabled={isListLoading}>
        Reset Filters
      </button>
    </div>
  );
};

export default React.memo(GameFilters);